import { AgentDetails, AgentDetailsLicenceType } from '@urbanx/agx.agencies.client';
import { AgentRole } from '@urbanx/agx.auth.client';

export const DefaultTeamMember: AgentDetails = {
  licenceType: AgentDetailsLicenceType.None,
  agencyId: '',
  id: '',
  firstName: '',
  lastName: '',
  title: '',
  email: '',
  phone: '',
  role: AgentRole.SalesAgent,
  teams: [],
  useLicenseeDetails: false,
  instructionsConditions: '',
  emailInvitationSent: false,
  agentCompanyDetails: {
    licenseeName: undefined,
    abn: undefined,
    acn: undefined,
    licences: undefined,
  },
  photo: undefined,
  softDeleted: false,
};
